module.exports = __webpack_public_path__ + "img/Loading_xh_0.0511897b.png";